import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LOCALES, useLocale } from "@/i18n/LocaleContext";

/* Injects hreflang alternate <link> tags for every supported locale
   plus x-default, pointing to the current path with each locale prefix. */
export const HreflangTags = () => {
  const { pathWithoutLocale } = useLocale();
  const location = useLocation();

  useEffect(() => {
    const origin = window.location.origin;
    // Clean up previously-injected tags
    document.head.querySelectorAll('link[data-qcm-hreflang="1"]').forEach((n) => n.remove());
    // canonical
    const canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("data-qcm-hreflang", "1");
    canonical.setAttribute("href", origin + location.pathname);
    document.head.appendChild(canonical);

    LOCALES.forEach((l) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", l);
      link.setAttribute("data-qcm-hreflang", "1");
      link.setAttribute(
        "href",
        origin + `/${l}${pathWithoutLocale === "/" ? "" : pathWithoutLocale}`
      );
      document.head.appendChild(link);
    });
    // x-default → EN
    const xdef = document.createElement("link");
    xdef.setAttribute("rel", "alternate");
    xdef.setAttribute("hreflang", "x-default");
    xdef.setAttribute("data-qcm-hreflang", "1");
    xdef.setAttribute("href", origin + `/en${pathWithoutLocale === "/" ? "" : pathWithoutLocale}`);
    document.head.appendChild(xdef);
  }, [location.pathname, pathWithoutLocale]);

  return null;
};

export default HreflangTags;
